module.exports = __webpack_public_path__ + "img/title.e12d89f3.png";